import { render, staticRenderFns } from "./shp-json.vue?vue&type=template&id=d1546c96&scoped=true"
import script from "./shp-json.vue?vue&type=script&lang=js"
export * from "./shp-json.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1546c96",
  null
  
)

export default component.exports